import * as Yup from 'yup'
import { Form } from 'react-bootstrap'

export const Schema = (settings) => Yup.object().shape({});

export const HoneyPotSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    return (
        <>
            {/* H.o.n.e.y.p.o.t */}
            <div style={{
                opacity: 0,
                position: "absolute",
                top: 0,
                left: 0,
                height: 0,
                width: 0,
                zIndex: -1
            }}>
                <Form.Group id="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control autoComplete="0" type="name" id="name" name="name" tabIndex={-1}
                        onChange={handleChange}></Form.Control>
                </Form.Group>
                <Form.Group id="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control autoComplete="0" type="email" id="email" name="email" tabIndex={-1}
                        onChange={handleChange}></Form.Control>
                </Form.Group>
            </div>
        </>
    );
};